import * as React from 'react';

import * as styles from './DefaultContactsLayout.css';

export interface IDefaultContactsLayoutProps {
  callbackButton?: React.ReactNode;
  contactsButton?: React.ReactNode;
  flatViewButton?: React.ReactNode;
}

export const DefaultContactsLayout: React.FC<React.PropsWithChildren<IDefaultContactsLayoutProps>> = ({
  callbackButton,
  contactsButton,
  flatViewButton,
}) => {
  return (
    <div className={styles['container']}>
      {contactsButton}
      {(callbackButton || flatViewButton) && (
        <div className={styles['buttons-row']}>
          {flatViewButton && <div className={styles['button']}>{flatViewButton}</div>}
          {callbackButton && <div className={styles['button']}>{callbackButton}</div>}
        </div>
      )}
    </div>
  );
};
